import { teamStrategy } from './links';

// Use the same strategy payload as the manual Save button.
export const saveChrisStrategy = async ({ formation, tactics, players, delegate }) => {
  const valid = players?.length === 11 && new Set(players.map((p) => p._id)).size === 11 &&
    players.every((p) => p._id && p.current_position);
  if (!valid) throw new Error('Chris did not return a complete starting eleven.');
  const response = await fetch(teamStrategy, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=utf-8' },
    body: JSON.stringify({
      formation,
      effort: tactics.effort,
      mindset: tactics.mindset,
      players: players.map((p) => ({ _id: p._id, pos: p.current_position })),
      ...(typeof delegate === 'boolean' ? { isAutoFormationEnabled: delegate } : {}),
    }),
  });
  if (response.status !== 200) throw new Error('Chris’s lineup could not be saved. Please try again.');
};
